export const languages = ["en", "dan"];

export const language = [
  {
    label: "English",
    value: "en",
  },
  {
    label: "Danish",
    value: "da",
  },
];

export const languageOptions = [
  {
    label: "English",
    value: "en",
  },
  {
    label: "Norsk",
    value: "no",
  },
  {
    label: "Français",
    value: "fr",
  },
  {
    label: "Deutsch",
    value: "de",
  },
  {
    label: "Italiano",
    value: "it",
  },
  {
    label: "Español",
    value: "es",
  },
  {
    label: "Język polski",
    value: "pl",
  },
];
